module.exports = __webpack_public_path__ + "img/assignments.1367d63b.png";